export const COGNITO = {
  REGION: process.env.REACT_APP_REGION,
  USER_POOL_ID: process.env.REACT_APP_POOL_ID,
  APP_CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
};
